/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';
import CustomDataGrid from '../contexts/CustomDataGrid';

const column1 = [
  {
    field: 'SKU',
    headerName: 'SKU',
    width: 300,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'PartNumber',
    headerName: 'Part Number',
    width: 300,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Part_Desc',
    headerName: 'Part Description',
    width: 300,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Each',
    headerName: 'Each',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Overpack_Count',
    headerName: 'Overpack Count',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Pallet_Count',
    headerName: 'Pallet Count',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
];
const column2 = [
  {
    field: 'SKU',
    headerName: 'SKU',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'PartNumber',
    headerName: 'Part Number',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Part_Desc',
    headerName: 'Part Description',
    width: 450,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'TotalQty',
    headerName: 'Total Quantity',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Overpack_Count',
    headerName: 'Overpack Count',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Pallet_Count',
    headerName: 'Pallet Count',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
];

const column3 = [
  {
    field: 'SKU',
    headerName: 'SKU',
    width: 300,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Item',
    headerName: 'Part Number',
    width: 300,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Item_Description',
    headerName: 'Part Description',
    width: 600,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Quantity',
    headerName: 'Quantity',
    width: 250,
    headerAlign: 'left',
    align: 'left',
  },
];

const Summary = () => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 8)),
  );
  const [endDate, setEndDate] = useState(
    new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1)),
  );
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [activePill, setActivePill] = useState('home');
  const { activeMenu, themeSettings } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        SummaryTable();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(
        new Date(
          new Date(new Date().getTime()).setDate(new Date().getDate() - 8),
        ),
      ); // for compulsory dates
      setEndDate(
        new Date(
          new Date(new Date().getTime()).setDate(new Date().getDate() - 1),
        ),
      ); // for compulsory dates
    }
  }, [startDate, endDate]);

  const SummaryTable = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({
      UserId:
        JSON.parse(localStorage.getItem('loginID')) === null || undefined
          ? null
          : JSON.parse(localStorage.getItem('loginID')).UserId,
      ProcessName: 'SimpliSafePortal',
      PageName: 'Summaries',
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(`${variables.BASE_URL}Summaries`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (
          JSON.parse(result)?.IsSuccess !== false
          && JSON.parse(result)?.IsAuthorize !== false
        ) {
          // console.log(JSON.parse(result).DailyProductReturnsActivity[0]);
          setTableData1(JSON.parse(result).Summaries);
          setTableData2(JSON.parse(result).CoreInv_Summary);
          setTableData3(JSON.parse(result).MaterialInv_Summary);
        }
        if (JSON.parse(result)?.IsSuccess !== true && JSON.parse(result)?.IsAuthorize) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData1([]);
          setTableData2([]);
          setTableData3([]);
        } else if (JSON.parse(result)?.IsAuthorize !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Access Denied!',
            });
            navigate('/');
          }, 0);
        }
        setLoading(false);
      });
  };

  const handlePillClick = (pill) => {
    setActivePill(pill);
  };

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div
          className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full "
          id="navMenu_id"
        >
          <Navbar />
        </div>
        <div className="container-fluid">
          {themeSettings}
          <div className="" style={{ marginTop: '5px' }} id="table_width">
            <ul className="nav nav-pills" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activePill === 'home' ? 'active' : ''}`}
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home"
                  type="button"
                  role="tab"
                  aria-controls="home"
                  aria-selected={activePill === 'home'}
                  style={{
                    width: '300px',
                    fontSize: '20px',
                    backgroundColor: activePill === 'home' ? '#ffb013' : '',
                    color: activePill === 'home' ? 'black' : '',
                  }}
                  onClick={() => handlePillClick('home')}
                >
                  <strong>FG Inventory</strong>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activePill === 'profile' ? 'active' : ''}`}
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile"
                  type="button"
                  role="tab"
                  aria-controls="profile"
                  aria-selected={activePill === 'profile'}
                  style={{
                    width: '300px',
                    fontSize: '20px',
                    backgroundColor: activePill === 'profile' ? '#ffb013' : '',
                    color: activePill === 'profile' ? 'black' : '',
                  }}
                  onClick={() => handlePillClick('profile')}
                >
                  <strong>Core Inventory</strong>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activePill === 'contact' ? 'active' : ''}`}
                  id="contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#contact"
                  type="button"
                  role="tab"
                  aria-controls="contact"
                  aria-selected={activePill === 'contact'}
                  style={{
                    width: '300px',
                    fontSize: '20px',
                    backgroundColor: activePill === 'contact' ? '#ffb013' : '',
                    color: activePill === 'contact' ? 'black' : '',
                  }}
                  onClick={() => handlePillClick('contact')}
                >
                  <strong>Material Inventory</strong>
                </button>
              </li>
            </ul>
            <div className=" tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                {loading ? (
                  <LoadingOverlay />
                ) : (
                  <Paper className="summarytable">
                    <Box className="summarytablebox">
                      <CustomDataGrid
                        name="FG Inventory Summary"
                        tableData={tableData1}
                        column={column1}
                      />
                    </Box>
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-35px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Paper>
                )}
              </div>

              <div
                className="tab-pane fade"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <div className="container-fluid">
                  <Paper className="summarytable">
                    <Box className="summarytablebox">
                      <CustomDataGrid
                        name="Core Inventory Summary"
                        tableData={tableData2}
                        column={column2}
                      />
                    </Box>
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-35px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Paper>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="contact"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                <div className="container-fluid">
                  <Paper className="summarytable">
                    <Box className="summarytablebox">
                      <CustomDataGrid
                        name="Material Inventory Summary"
                        tableData={tableData3}
                        column={column3}
                      />
                    </Box>
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-35px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Paper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
